<template>
    <v-card class="grey lighten-3">
        <v-container fluid grid-list-xs>
            <v-layout row>
                <v-flex xs6>
                    <div class="text-xs-left">
                        <span class="cyan--text text--darken-4 subtitle-1 font-weight-bold">
                            <v-icon color="cyan darken-3">mdi-clipboard-account-outline</v-icon>&nbsp; Información General
                        </span>
                    </div>
                </v-flex>
                <v-flex xs6 class="text-xs-center text-end">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="bEdit" icon @click="onEdit" v-on="on">
                                <v-icon color="orange darken-2">mdi-square-edit-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar información general</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="!bEdit" icon @click="onSave" v-on="on">
                                <v-icon color="orange darken-2">mdi-clipboard-check-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Guardar información general</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn :disabled="!bEdit" icon @click="onCancel" v-on="on">
                                <v-icon color="orange darken-2">mdi-pencil-off</v-icon>
                            </v-btn>
                        </template>
                        <span>Cancelar edición</span>
                    </v-tooltip>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <v-card flat class="grey lighten-3">
                        <v-container pa-0 fluid grid-list-xs>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-tabs background-color="cyan darken-2" dark show-arrows>
                                        <v-tab class="text-none">Historia Clínica</v-tab>
                                        <v-tab class="text-none">Identificación</v-tab>
                                        <v-tab class="text-none">Información complementaria</v-tab>
                                        <v-tab class="text-none">Información de contacto</v-tab>
                                        <v-tab class="text-none">Familiares/Responsable</v-tab>

                                        <!--****************************** Tab Historia Clínica: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat class="grey lighten-4">
                                                <v-card-text>
                                                    <v-container fluid grid-list-xs>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.notes"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="red"
                                                                    label="Notas"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.familyHistory"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Antecedentes heredo-familiares"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.pathologicalHistory"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Antecedentes personales patológicos"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.nonPathologicalHistory"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Antecedentes personales no patológicos"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.allergies"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Alergias"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.gynecoObstetricHistory"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Antecedentes Gineco-Obstétricos"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.activeDx"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Diagnósticos activos"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs12 md3>
                                                                <v-textarea
                                                                    dense
                                                                    outlined
                                                                    v-model="patient.activeTx"
                                                                    :auto-grow="false"
                                                                    no-resize
                                                                    color="cyan darken-3"
                                                                    label="Tratamientos activos"
                                                                    rows="3"
                                                                    :readonly="!bEdit"
                                                                ></v-textarea>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout
                                                            align-center
                                                            justify-start
                                                            row
                                                            fill-height
                                                        >
                                                            <v-flex xs6 sm4 md3>
                                                                <v-select
                                                                    dense
                                                                    label="Tipo de Sangre"
                                                                    v-model="patient.bloodTypeID"
                                                                    color="cyan darken-3"
                                                                ></v-select>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Identificación: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid grid-list-xs>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs12 md3>
                                                                <v-text-field
                                                                    label="CURP"
                                                                    v-model="patient.curp"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Apellido paterno"
                                                                    v-model="patient.lastName1"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Apellido materno"
                                                                    v-model="patient.lastName2"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Nombre"
                                                                    v-model="patient.name"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Pseudónimo"
                                                                    v-model="patient.pseudonym"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify-space-between>
                                                            <v-flex xs12 md2>
                                                                <v-select
                                                                    label="Sexo"
                                                                    v-model="patient.sex"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-select>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-select
                                                                    label="Estado Civil"
                                                                    v-model="patient.civilState"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-select>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Apellido de casada"
                                                                    v-model="patient.spouseLastName"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-menu
                                                                    v-model="bMenuBirthDay"
                                                                    :close-on-content-click="false"
                                                                    :nudge-right="40"
                                                                    transition="scale-transition"
                                                                    offset-y
                                                                    min-width="290px"
                                                                >
                                                                    <template
                                                                        v-slot:activator="{on}"
                                                                    >
                                                                        <v-text-field
                                                                            :dense="bDense"
                                                                            color="cyan darken-3"
                                                                            v-model="patient.birthDay"
                                                                            label="Fecha de nacimiento"
                                                                            prepend-icon="mdi-calendar"
                                                                            readonly
                                                                            v-on="on"
                                                                        ></v-text-field>
                                                                    </template>
                                                                    <v-date-picker
                                                                        color="cyan darken-3"
                                                                        v-model="patient.birthDay"
                                                                        @input="bMenuBirthDay = false"
                                                                        :readonly="!bEdit"
                                                                    ></v-date-picker>
                                                                </v-menu>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md3>
                                                                <v-text-field
                                                                    label="Edad"
                                                                    v-model="age"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify-space-between>
                                                            <v-flex xs12 md3>
                                                                <v-text-field
                                                                    label="Nacionalidad"
                                                                    v-model="patient.citizenship"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md2>
                                                                <v-text-field
                                                                    label="Religión"
                                                                    v-model="patient.religion"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md3>
                                                                <v-text-field
                                                                    label="Ocupación"
                                                                    v-model="patient.ocupation"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md3>
                                                                <v-text-field
                                                                    label="Escolaridad"
                                                                    v-model="patient.education"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Información Complementaria: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout align-center justify-start row>
                                                            <v-flex xs12 sm6>
                                                                <v-container grid-list-xs fluid>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 md6>
                                                                            <v-checkbox
                                                                                dense
                                                                                label="Discapacidad motriz"
                                                                                v-model="patient.motorDisability"
                                                                                color="orange accent-4"
                                                                                :readonly="!bEdit"
                                                                            ></v-checkbox>
                                                                        </v-flex>

                                                                        <v-flex xs12 md6>
                                                                            <v-checkbox
                                                                                dense
                                                                                label="Discapacidad mental"
                                                                                v-model="patient.mentalDisability"
                                                                                color="orange accent-4"
                                                                                :readonly="!bEdit"
                                                                            ></v-checkbox>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 md6>
                                                                            <v-checkbox
                                                                                dense
                                                                                label="Discapacidad visual"
                                                                                v-model="patient.visualDisability"
                                                                                color="orange accent-4"
                                                                                :readonly="!bEdit"
                                                                            ></v-checkbox>
                                                                        </v-flex>

                                                                        <v-flex xs12 md6>
                                                                            <v-checkbox
                                                                                dense
                                                                                label="Discapacidad auditiva"
                                                                                v-model="patient.hearingImpairment"
                                                                                color="orange accent-4"
                                                                                :readonly="!bEdit"
                                                                            ></v-checkbox>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-textarea
                                                                                dense
                                                                                v-model="patient.otherDisability"
                                                                                :auto-grow="true"
                                                                                color="cyan darken-3"
                                                                                label="Otra discapacidad"
                                                                                rows="3"
                                                                                :readonly="!bEdit"
                                                                            ></v-textarea>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-flex>
                                                            <v-flex xs12 sm6>
                                                                <v-container fluid>
                                                                    <v-layout row align-start>
                                                                        <v-flex xs12>
                                                                            <v-text-field
                                                                                label="Seguridad social"
                                                                                v-model="patient.socialSecurity"
                                                                                color="cyan darken-3"
                                                                                :readonly="!bEdit"
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-text-field
                                                                                label="Seguridad privada"
                                                                                v-model="patient.privateSecurity"
                                                                                color="cyan darken-3"
                                                                                :readonly="!bEdit"
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row>
                                                                        <v-flex xs12>
                                                                            <v-text-field
                                                                                label="Referido por:"
                                                                                v-model="patient.referedFrom"
                                                                                color="cyan darken-3"
                                                                                :readonly="!bEdit"
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Contacto: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs9 sm9 md4>
                                                                <v-text-field
                                                                    label="Calle"
                                                                    v-model="patient.address.street"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs3 sm2 md2>
                                                                <v-text-field
                                                                    label="Número"
                                                                    v-model="patient.address.number"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs11 sm6 md3>
                                                                <v-text-field
                                                                    label="Colonia"
                                                                    v-model="patient.address.colonia"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs8 sm6 md2>
                                                                <v-text-field
                                                                    label="C.P."
                                                                    v-model="patient.address.cp"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify-space-between>
                                                            <v-flex xs9 sm9 md4>
                                                                <v-text-field
                                                                    label="Municipio"
                                                                    v-model="patient.address.municipio"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md4>
                                                                <v-text-field
                                                                    label="Estado"
                                                                    v-model="patient.address.state"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md4>
                                                                <v-text-field
                                                                    label="Colonia"
                                                                    v-model="patient.address.country"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row justify-space-between>
                                                            <v-flex xs9 sm6 md3>
                                                                <v-text-field
                                                                    label="Teléfono 1"
                                                                    v-model="patient.address.phone1"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm6 md3>
                                                                <v-text-field
                                                                    label="Teléfono 2"
                                                                    v-model="patient.address.phone2"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm6 md3>
                                                                <v-text-field
                                                                    label="Celular"
                                                                    v-model="patient.address.mobile"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm6 md3>
                                                                <v-text-field
                                                                    label="Correo electrónico"
                                                                    v-model="patient.address.email"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!--****************************** Tab Responsable: ************************************* -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-container fluid>
                                                        <v-layout row justify-space-between>
                                                            <v-flex xs9 sm9 md2>
                                                                <v-text-field
                                                                    label="Apellido paterno"
                                                                    v-model="patient.family[0].lastName1"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md2>
                                                                <v-text-field
                                                                    label="Apellido materno"
                                                                    v-model="patient.family[0].lastName2"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md2>
                                                                <v-text-field
                                                                    label="Nombre"
                                                                    v-model="patient.family[0].name"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md2>
                                                                <v-text-field
                                                                    label="Teléfono"
                                                                    v-model="patient.family[0].phone"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs9 sm9 md3>
                                                                <v-select
                                                                    label="Relación con el paciente"
                                                                    v-model="patient.family[0].relationship"
                                                                    color="cyan darken-3"
                                                                    :readonly="!bEdit"
                                                                ></v-select>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                    </v-tabs>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ClinicalHistory',
    data() {
        return {
            bEdit: false,
            bMenuBirthDay: false,
            age: ''
        };
    },
    props: {
        patient: Object
    },
    components: {},
    created() {},
    methods: {
        onEdit() {
            this.bEdit = true;
        },
        onCancel() {
            this.bEdit = false;
        },
        onSave() {
            this.bEdit = false;
        }
    },
    computed: {
        ...mapGetters(['waitCursor'])
    }
};
</script>

<style scoped>
.gmp-green {
    color: #0097a7;
}
</style>